import React from 'react';

const WinManagerContext = React.createContext();

export default WinManagerContext;
